import {useContext} from 'react';
import {WebSocketConnectionProviderContext} from '../providers/WebSocketConnectionProvider';

const useWebSocketConnection = () => {
  const webSocketConnection = useContext(WebSocketConnectionProviderContext);
  return webSocketConnection;
};

export default useWebSocketConnection;
